/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_CadenceInputs */

const en_ui_chart_series_cadence = /** @type {(inputs: Ui_Chart_Series_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadence (rpm)`)
};

const de_ui_chart_series_cadence = /** @type {(inputs: Ui_Chart_Series_CadenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadenz (rpm)`)
};

/**
* | output |
* | --- |
* | "Cadence (rpm)" |
*
* @param {Ui_Chart_Series_CadenceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_cadence = /** @type {((inputs?: Ui_Chart_Series_CadenceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_CadenceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_cadence(inputs)
	return de_ui_chart_series_cadence(inputs)
});